<template>
  <div class="w-100">
    <div v-if="error !== undefined" class="row">
      <div class="col-12">
        <div class="alert alert-danger" role="alert">
          <h4>
              {{ error }}
          </h4>
        </div>
      </div>
    </div>
    <div
      v-if="auction.status === 'hot'"
      class="row row-cols-lg-2 row-cols-1 main-content bg-card-shadow hotbid-area"
    >
      <hot-lot-component
        v-for="slot in slots"
        :time="time"
        :hot_slot="slot"
        :auction_id="auction_id"
        :auction_type="auction_type"
      />
    </div>
    <div class="row my-3">
      <div class="col-md-3 sidebar order-md-1 order-2">
        <auction-filter-component v-model="filters" :fuels="fuels" v-on:reset="filterReset()"/>
      </div>
      <div class="col-md-9 main-content order-1 order-md-2">
        <div class="col-inner">

          <transition-group v-if="auction.fix_price" name="lots">
            <div
              v-for="lot in getFilteredLots()"
              :key="lot.id"
              class="card mb-3">
              <fix-price-lot-component
                :lot="lot"
                :auction_id="auction_id"
                :reserve_time="auction.reserve_max_hours"
              />
            </div>
          </transition-group>
          <transition-group v-else name="lots">
            <div
              v-for="lot in getFilteredLots()"
              :key="lot.id"
              class="col mb-sm-3"
            >
              <lot-component
                :time="time"
                :lot="lot"
                :auction_id="auction_id"
                :auction_type="auction_type"
              />
            </div>
          </transition-group>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TimerComponent from "../TimerComponent";
import HotLotComponent from "./HotLotComponent";
import LotComponent from "./LotComponent";
import FixPriceLotComponent from "./FixPriceLotComponent";
import AuctionFilterComponent from "./AuctionFilterComponent";

const personbilList = [
  'Personbil,- unntatt ambulanse',
  'Personbil (Ambulanse)',
  'Personbil (Leilighetsambulanse) registrert første gang her i landet før 1.10.2006',
];

const varebilList = [
  'Varebil,- registrert første gang her i landet før 1.1.1981 og varebil (Klasse 1) registrert første gang her i landet 1.1.1981 eller senere',
  'Varebil (Klasse 2),- registrert første gang her i landet 1.1.1981 eller senere',
  'Varebil (Klasse 1),- fortollet etter 31.3.2001',
  'Varebil (Klasse 2),- fortollet etter 31.3.2001',
];

export default {
  props: ['auction_id', 'auction_type', 'prop_fuels'],
  components: {AuctionFilterComponent, LotComponent, HotLotComponent, TimerComponent, FixPriceLotComponent},
  mounted() {
    this.fuels = JSON.parse(this.prop_fuels)
    this.getLots()
    this.broadcast()
  },
  created() {
    setInterval(this.ping, 5 * 60 * 1000);
  },
  data() {
    return {
      slots: {},
      auction: {status: 'active'},
      lots: [],
      time: 0,
      error: undefined,
      fuels: [],
      filters: {
        model: '',
        price_start: '',
        price_end: '',
        fuels: [],
        gearbox: '',
        driving: '',
        tax_group: ''
      }
    }
  },
  methods: {
    ping() {
      axios.get('/ping')
    },
    filterReset() {
      this.filters = {
        model: '',
        price_start: '',
        price_end: '',
        fuels: [],
        gearbox: '',
        driving: '',
        tax_group: ''
      }
    },
    getFilteredLots() {
      return this.lots.filter(lot => {
        let enableFiltersCount = 0
        let foundValuesFromFilters = 0

        for (let filterIndex in this.filters) {
          if (this.filters[filterIndex] !== '' && filterIndex !== 'fuels') {
            enableFiltersCount++;
            if (filterIndex === 'model') {
              if (lot.car.name.toUpperCase().indexOf(this.filters.model.toUpperCase()) !== -1) {
                foundValuesFromFilters++
              }
            } else if (filterIndex === 'year_start') {
              if (lot.car.year >= this.filters[filterIndex]) {
                foundValuesFromFilters++
              }
            } else if (filterIndex === 'year_end') {
              if (lot.car.year <= this.filters[filterIndex]) {
                foundValuesFromFilters++
              }
            } else if (filterIndex === 'tax_group') {
              if (this.filters[filterIndex] == 'personbil') {
                if (personbilList.includes(lot.car.tax_group)) {
                  foundValuesFromFilters++
                }
              } else if (this.filters[filterIndex] == 'varebil') {
                if (varebilList.includes(lot.car.tax_group)) {
                  foundValuesFromFilters++
                }
              } else if (this.filters[filterIndex] == 'annet') {
                if (![].concat(personbilList, varebilList).includes(lot.car.tax_group)) {
                  foundValuesFromFilters++
                }
              }

            } else if (this.filters[filterIndex] !== '') {
              if (typeof lot.car[filterIndex] === "string" && typeof this.filters[filterIndex] === "string") {
                if (lot.car[filterIndex].toUpperCase() == this.filters[filterIndex].toUpperCase()) {
                  foundValuesFromFilters++
                }
              } else {
                if (lot.car[filterIndex] == this.filters[filterIndex]) {
                  foundValuesFromFilters++
                }
              }

            }
          } else if (filterIndex === 'fuels') {
            if (this.filters.fuels.length > 0) {
              enableFiltersCount++;
              if (this.filters.fuels.includes(lot.car.fuel)) {
                foundValuesFromFilters++
              }
            }
          }
        }
        return enableFiltersCount === foundValuesFromFilters
      })
    },
    getLots: function () {
      axios({
        url: `/auctions/${this.auction_id}/lots/ajax/`,
        method: 'GET'
      }).then(resp => {
        this.lots = resp.data.lots
        this.auction = resp.data.auction
        for (let i = 1; i <= resp.data.auction.hot_bid_amount_car; i++) {
          this.slots[i] = {free: true, lot: {rate: 0, car: {}}}
        }
        this.lots.forEach(lot => {
          let rate = this.checkMeRate(lot, lot)
          lot.me_rate = rate.me_rate
          lot.show_message_rate = rate.show_message_rate
          lot.autoRate = lot.auto_rates[0] == undefined ? '' : lot.auto_rates[0].rate
        })
        resp.data.hot_lots.forEach(lot => {
          for (let slot_number in this.slots) {
            if (this.slots[slot_number].free) {
              this.slots[slot_number].lot = lot
              let rate = this.checkMeRate(lot, lot)
              this.slots[slot_number].lot.me_rate = rate.me_rate
              this.slots[slot_number].lot.show_message_rate = rate.show_message_rate
              this.slots[slot_number].free = false
              break
            }
          }
        })

        this.time = resp.data.time
      }).catch(resp => {
        this.error = resp.response.data.message
      })

    },
    broadcast() {
      Echo.private('users.' + this.current_user_id)
        .listen('update', (e) => {
          this.lots.forEach(lot => {
            if (lot.id === e.auto_rate.lot_id) {
              lot.auto_rates[0] = e.auto_rate
            }
          })
        })
      Echo.private('auctions.' + this.auction_id)
        .listen('reload', (e) => {
            console.log('reload')
            this.window.location.reload();
        })
      Echo.private('lots.' + this.auction_id)
        .listen('update', (e) => {
          this.lots.forEach(lot => {
            if (lot.id === e.lot.id) {
              lot.rate = e.lot.rate
              lot.time_end = e.lot.time_end
              let rate = this.checkMeRate(lot, e.lot)
              if (rate.me_rate) {
                lot.rates.unshift({rate: e.lot.rate})
              }
              lot.me_rate = rate.me_rate
              lot.show_message_rate = rate.show_message_rate
            }
          })
        })
        .listen('delete', (e) => {
          this.lots.forEach((lot, index) => {
            if (lot.id === e.lot.id) {

            }
          })
          this.checkLots()
        })
      Echo.private('hot_lots.' + this.auction_id)
        .listen('update', (e) => {
          for (let slot_number in this.slots) {
            if (this.slots[slot_number].lot.id === e.lot.id) {
              let rate = this.checkMeRate(this.slots[slot_number].lot, e.lot)
              if (rate.me_rate) {
                this.slots[slot_number].lot.rates.unshift({rate: e.lot.rate})
              }
              this.slots[slot_number].lot.me_rate = rate.me_rate
              this.slots[slot_number].lot.show_message_rate = rate.show_message_rate
              this.slots[slot_number].lot.rate = e.lot.rate
              this.slots[slot_number].lot.time_end = e.lot.time_end
            }
          }
        })
        .listen('add', (e) => {
          if (this.auction.status !== 'hot') this.auction.status = 'hot'

          for (let slot_number in this.slots) {
            if (this.slots[slot_number].free) {
              this.slots[slot_number].free = false
              let rate = {
                me_rate: false,
                show_message_rate: false
              }
              let rates = []

              //Timeout для плавной отрисовки
              setTimeout(() => {
                this.lots.forEach((lot, index) => {
                  if (lot.id === e.lot.id) {
                    rate = this.checkMeRate(lot, e.lot)
                    rates = lot.rates
                    this.slots[slot_number].lot = lot

                    // Object.assign(this.slots[slot_number].lot, lot)
                    this.lots.splice(index, 1)
                  }
                })

                this.slots[slot_number].lot.time_end = e.lot.time_end
                this.slots[slot_number].lot.me_rate = rate.me_rate
                this.slots[slot_number].lot.show_message_rate = rate.show_message_rate
                this.slots[slot_number].lot.rates = rates
              }, 450);
              break
            }
          }
        })
        .listen('delete', (e) => {
          for (let slot_number in this.slots) {
            if (this.slots[slot_number].lot.id === e.lot.id) {
              this.slots[slot_number].free = true
              this.slots[slot_number].lot = {
                car: {}
              }
            }
          }
          this.checkLots()
        })
      Echo.channel('time')
        .listen('update', (e) => {
          this.time = e.time
        })

    },
    checkMeRate(old_lot, new_lot) {
      let me_rate = false
      let show_message_rate = false

      if (this.auction_type === 'open' && new_lot.rate != 0) {
        if (this.current_user_id == new_lot.max_rate_client_user_id) {
          me_rate = true
          show_message_rate = true
        } else if (new_lot.old_max_rate_client_user_id == this.current_user_id && new_lot.max_rate_customer !== this.current_user_id) {
          show_message_rate = true
        }
      }

      return {me_rate, show_message_rate}
    },
    checkLots() {
      if (this.lots.length === 0) {
        let found = false
        for (let slot_number in this.slots) {
          if (!this.slots[slot_number].free) {
            found = true
          }
        }
        if (found) {
          this.error = undefined
        } else {
          this.error = 'Alle bilene I denne auksjonen er avsluttet'
        }
      } else {
        this.error = undefined
      }
    }
  }
}
</script>
<style>

</style>
